import { HourlyDataPoint } from "src/redux/admin/reporting/reporting.types";
import { HourlyMetrics } from "../components/metric-time-of-day-display/types";


const transformHourlyData = (rawHourlyData: HourlyDataPoint[]): HourlyMetrics[] => {
  return rawHourlyData.map((data) => ({
    hour: parseInt(data.hour),
    clicks: data.clicks,
    impressions: data.impressions,
    spend: data.spend,
    conversions: data.conversions,
  }));
};

export default transformHourlyData;